const BaseView = require('./view').default;
const UiDataBuilder = require('../ui_data_builders/ui_data_builder.desktop');

module.exports = BaseView.extend({
    uiDataBuilder: new UiDataBuilder(),
    events: Odigeo._.merge(
        {
            'tap .checked_bags_one_click_load_more_button': 'onLoadMore',
            'tap .checked_bags_one_click_add_button': 'onAddOneClickBag',
        },
        BaseView.prototype.events
    ),
});
